$(document).ready(function(){
   $("#description-table").insertAfter(".replace-div");
    $( ".newsletter" ).insertAfter( "#replace-email-div-block" );
        $('.product__text.inline-richtext').click(function() {
            $('html, body').animate({
                scrollTop: $('#shopify-section-template--22687213584695__multicolumn_rrCNDk').offset().top
            }, 1000); // Adjust the duration (1000ms = 1s) as needed
        });

  
    });